import english from './packs/en-US'
import french from './packs/fr-FR'
import espanol from './packs/es-ES'
import italiano from './packs/it-IT'
import portugues from './packs/pt-PT'
import deutsch from './packs/de-DE'
import koreon from './packs/en-ko'
import netherlands from './packs/en-nl'
import spanish from './packs/es-MX'
import polish from './packs/en-pl'
import brazillian from './packs/pt-BR'
import chinese from './packs/zh-CN'

export default {
  'en-US': english,
  'fr-FR': french,
  'es-ES': espanol,
  'it-IT': italiano,
  'pt-PT': portugues,
  'de-DE': deutsch,
  'en': english,
  'fr': french,
  'es': espanol,
  'it': italiano,
  'pt': portugues,
  'de': deutsch,
  'en-ko': koreon,
  'en-nl': netherlands,
  'es-MX': spanish,
  'en-pl': polish,
  'pt-BR': brazillian,
  'zh-CN': chinese

}
